import { DisplayScreen } from '@oolio-group/domain';

interface BrandMarkProps {
  logoUri?: string;
  name?: string;
}

/**
 * The logo sits over the media, matching the idle screen. The store name is a
 * text fallback, so it only appears when there is no media behind it.
 */
export const resolveBrandMark = (
  config: DisplayScreen | undefined,
  hasMedia: boolean,
  storeName?: string,
): BrandMarkProps | null => {
  if (config?.logoUri) return { logoUri: config.logoUri };
  if (!hasMedia && storeName) return { name: storeName };
  return null;
};
